import type { StatFilterCatalog } from '../../types/statFilters';

/**
 * The stat filter catalogs read this visit, by sport. A catalog depends on the program's plan (the WAR
 * stats are a rankings feature), so it is dropped with the Player Database page cache whenever the
 * signed-in user, organization or impersonation changes (`AuthContext`).
 */
export const statFilterCatalogCache = new Map<string, Promise<StatFilterCatalog | null>>();

/** Forget the cached catalogs (a sign-out, a switch of view or organization, a test). */
export const clearStatFilterCatalogCache = (): void => statFilterCatalogCache.clear();
